import polyglotI18nProvider from 'ra-i18n-polyglot';
import raEnglishMessages from 'ra-language-english';
import raFrenchMessages from 'ra-language-french';
import { validateFourCharsCode } from './utils/validation';

const englishMessages = {
  ...raEnglishMessages,
  'ra-relationships': {
    duallistinput: { select: 'Add', unselect: 'Remove' },
  },
  authentication: {
    login: {
      submit: 'Login',
      forgotPassword: 'Forgot password?',
      username: 'Username',
    },
    forgotPassword: {
      submit: 'Submit',
      email: 'Email',
      cardContent:
        'Please enter your email address above.\nYou will receive an email with a code that you can redeem to reset your password.',
      verification: 'Verification Code',
      verificationCardContent:
        'We just sent you an email with a verification code attached.\nPlease enter this here and type your new password below to reset.',
      newPassword: 'New Password',
    },
    changePassword: {
      password: 'Password',
      verificationCode: 'Verification Code',
      newPassword: 'New Password',
      cardContent:
        'We just sent you an email with a verification code attached.\nPlease enter this here and type your new password below to reset.',
      submit: 'Reset Password',
    },
    forceChangePassword: {
      cardContent: 'Please change your password to continue signing in.',
      submit: 'Change Password',
    },
  },
  resources: {
    user: {
      name: 'User |||| Users',
      fields: {
        id: 'ID',
        name: 'Name',
        role: "User's Role",
      },
    },
    admin: {
      name: 'Admin |||| Admins',
      titles: {
        edit: 'Admin Details',
        create: 'Create Admin',
      },
    },
    plot: {
      name: 'Plot |||| Plots',
      titles: {
        edit: 'Plot Details',
        create: 'Create Plot',
      },
      tabs: {
        details: 'Details',
        evidence: 'Evidence',
        suspects: 'Suspects',
      },
    },
    template: {
      name: 'Template |||| Templates',
      titles: {
        edit: 'Template Details',
        create: 'Create Template',
      },
    },
    plotSuspect: {
      name: 'Plot Suspect |||| Plot Suspects',
      titles: {
        edit: 'Plot Suspect Details',
        create: 'Create Plot Suspect',
      },
    },
    plotEvidence: {
      name: 'Plot Evidence |||| Plot Evidences',
      titles: {
        edit: 'Plot Evidence Details',
        create: 'Create Plot Evidence',
      },
    },
    evidence: {
      name: 'Evidence |||| Evidences',
      titles: {
        edit: 'Evidence Details',
        create: 'Create Evidence',
      },
    },
    location: {
      name: 'Location |||| Locations',
      titles: {
        edit: 'Location Details',
        create: 'Create Location',
      },
    },
    event: {
      name: 'Event |||| Events',
      titles: {
        edit: 'Event Details',
        create: 'Create Event',
      },
      tabs: {
        details: 'Details',
        evidence: 'Evidence',
        suspect: 'Suspects',
        superSleuth: 'Super Sleuth',
      },
    },
    eventEvidence: {
      name: 'Event Evidence |||| Event Evidences',
      titles: {
        edit: 'Event Evidence Details',
        create: 'Create Event Evidence',
      },
    },
    eventSuspect: {
      name: 'Event Suspect |||| Event Suspects',
      titles: {
        edit: 'Event Suspect Details',
        create: 'Create Event Suspect',
      },
    },
    eventSuperSleuth: {
      name: 'Event Super Sleuth |||| Event Super Sleuths',
      titles: {
        edit: 'Event Super Sleuth Details',
        create: 'Create Event Super Sleuth',
      },
    },
  },
  error: {
    generic: 'Something went wrong. Please try again',
    permissions: {
      title: 'Access Denied',
      header: 'You do not have the required permissions to view this page',
      subtitle: 'Contact your administrator for necessary permissions',
    },
    form: {
      multiLang: {
        missingField:
          'The "%{source}" field is not complete for the %{language} translation',
        noLocalisations: 'Must have at least one defined localisation',
      },
    },
    field: {
      number: {
        notInt: 'Not an integer',
        minIs1: 'Must be greater than zero',
      },
      image: {
        notFound: 'Image not found',
      },
      file: {
        notFound: 'No file found',
      },
      text: {
        invalidEmail: 'Not a valid email address',
      },
    },
    session: {
      expired: 'Session expired',
    },
  },
  messages: {
    na: 'N/A',
    view: 'View',
    unknown: 'Unknown',
  },
  choices: {
    generic: {
      boolean: {
        true: 'Yes',
        false: 'No',
      },
    },
    admin: {
      role: {
        super_admin: 'Super Admin',
        admin: 'Admin',
        event_director: 'Event Director',
      },
    },
    evidence: {
      type: {
        police_folder: 'Police Manilla Folder',
        letter: 'Letter Open envelope',
        article: 'Article Page open',
        device: 'Device Phone unlock',
        book: 'Book Open (Generic cover)',
      },
      fields: {
        pdf: 'PDF FILE'
      },
      uploadChoice: {
        pdf: 'Pdf',
        editor: 'Editor',
        image: 'Image'
      }
    },
    status: {
      draft: 'Draft',
      published: 'Published',
    },
    eventStatus: {
      draft: 'Draft',
      published: 'Published',
      digiticketsDraft: 'Digitickets Draft',
      inProgress: 'In Progress',
      completed: 'Completed',
      allActive: 'All Active'
    },
    dateRange: {
      thisMonth :'This Month',
      lastMonth :'Last Month' ,
      thisYear :'This Year' ,
      lastYear :'Last Year',
      lastSevenDays :'Last 7 Days' ,
      lastThirtyDyas :'Last 30 Days',
    }
  },
  multiLang: {
    button: {
      removeTranslation: 'Remove Translation',
    },
  },
  validation: {
    passwdSpecial: 'Password must contain a special character (?!#%$)',
    passwdNumber: 'Password must contain a number',
    passwdLower: 'Password must contain a lowercase character',
    passwdUpper: 'Password must contain an uppercase character',
    passwdMinLen: 'Password must be at least 8 characters',
    passwdMaxLen: 'Password must be no more than 99 characters',
    passwdNoMatch: 'The passwords do not match',
    invalidEmail: 'Invalid email format',
    invalidPhone: 'Not a valid phone number of the form +17895551234',
    invalidUrl: 'Invalid URL format',
    notAnInt: 'Not an integer',
    positivieNonZeroInt: 'Please enter a number greater than 0',
    positivieInt: 'Please enter a positive integer',
    imageMaxSize: 'Image file is too large. Maximum size is 5MB.',
    imageInvalidType:
      'Invalid file type. Please upload a jpg, jpeg, png or webp image.',
    imageInvalid:
      'Image must be jpg, jpeg, png or webp and no larger than 5MB.',
    validateFourStringCode:
      'The code must be four numerals long, and can only comprise numbers between 1 and 9 with no repeated values',
    validatePostCode: 'Please enter a valid UK Post Code',
    validateFolderNumber: 'Folder number must be from 1 to 10',
    validateDressCode: 'Maximum of 35 characters allowed'
  },
};

// combine react-admin default translations for french + google translate for our english messages above
const frenchMessages = {
  ...raFrenchMessages,
  'ra-relationships': {
    duallistinput: { select: 'Ajouter', unselect: 'Supprimer' },
  },
  authentication: {
    login: {
      submit: 'Connexion',
      forgotPassword: 'Mot de passe oublié?',
      username: "Nom d'utilisateur",
    },
    forgotPassword: {
      submit: 'Soumettre',
      email: 'E-mail',
      cardContent:
        'Veuillez saisir votre adresse e-mail ci-dessus.\nVous recevrez un e-mail avec un code que vous pourrez utiliser pour réinitialiser votre mot de passe.',
      verification: 'Code de vérification',
      verificationCardContent:
        'Nous venons de vous envoyer un e-mail avec un code de vérification en pièce jointe.\nVeuillez le saisir ici et saisir votre nouveau mot de passe ci-dessous pour le réinitialiser.',
      newPassword: 'Nouveau mot de passe',
    },
    changePassword: {
      password: 'Mot de passe',
      verificationCode: 'Code de vérification',
      newPassword: 'Nouveau mot de passe',
      cardContent:
        'Nous venons de vous envoyer un e-mail avec un code de vérification en pièce jointe.\nVeuillez le saisir ici et saisir votre nouveau mot de passe ci-dessous pour le réinitialiser.',
      submit: 'réinitialiser le mot de passe',
    },
    forceChangePassword: {
      cardContent:
        'Veuillez modifier votre mot de passe pour continuer à vous connecter.',
      submit: 'Changer le mot de passe',
    },
  },
  resources: {
    user: {
      name: 'Utilisateur |||| Utilisateurs',
      fields: {
        id: 'Identifiant',
        name: 'Nom',
        role: "Rôle de l'utilisateur",
      },
    },
  },
  error: {
    generic: "Quelque chose s'est mal passé. Veuillez réessayer",
    permissions: {
      title: 'Accès refusé',
      header:
        "Vous n'avez pas les autorisations requises pour afficher cette page",
      subtitle:
        'Contactez votre administrateur pour les autorisations nécessaires',
    },
    form: {
      multiLang: {
        missingField:
          'Le champ "%{source}" n\'est pas complet pour la traduction %{language}',
        noLocalisations: 'Doit avoir au moins une localisation définie',
      },
    },
    field: {
      number: {
        notInt: 'Pas un entier',
        minIs1: 'Doit être supérieur à zéro',
      },
      image: {
        notFound: 'Image non trouvée',
      },
      file: {
        notFound: 'Aucun fichier trouvé',
      },
      text: {
        invalidEmail: 'Adresse courriel invalide',
      },
    },
    session: {
      expired: 'La session a expiré',
    },
  },
  messages: {
    na: '',
    view: 'Vue',
    unknown: 'Inconnu',
  },
  choices: {
    generic: {
      boolean: {
        true: 'Oui',
        false: 'Non',
      },
    },
  },
  multiLang: {
    button: {
      removeTranslation: 'Supprimer la traduction',
    },
  },
  validation: {
    passwdSpecial: 'Le mot de passe doit contenir un caractère spécial (?!#%$)',
    passwdNumber: 'Le mot de passe doit contenir un chiffre',
    passwdLower: 'Le mot de passe doit contenir un caractère minuscule',
    passwdUpper: 'Le mot de passe doit contenir un caractère majuscule',
    passwdMinLen: "Mot de passe doit être d'au moins 8 caractères",
    passwdMaxLen: 'Le mot de passe ne doit pas dépasser 99 caractères',
    passwdNoMatch: 'Le mot de passe ne correspond pas',
    invalidEmail: "Format d'email invalide",
    invalidPhone: 'Pas un numéro de téléphone valide de la forme +17895551234',
    invalidUrl: "Format d'URL non valide",
    notAnInt: 'Pas un entier',
    positivieNonZeroInt: 'Veuillez saisir un nombre supérieur à 0',
    positivieInt: 'Veuillez saisir un nombre entier positif',
  },
};

const i18nProvider = polyglotI18nProvider(
  (locale) => {
    switch (locale) {
      case 'en':
        return englishMessages;
      case 'fr':
        return frenchMessages;
      default:
        return englishMessages;
    }
  },
  'en',
  {
    allowMissing: true,
  }
);

export { englishMessages };

export default i18nProvider;
